import React, { useContext, memo } from 'react';
import { makeStyles } from "@material-ui/styles";
import i18next from "i18next";
import { EaseLivestreamContext } from "../index";
import avatar from "../../../common/images/defaultAvatar.png";
import joinIcon from '../../../common/images/join.png';
var useStyles = makeStyles(function (theme) {
  return {
    pulldownListItem: {
      padding: '10px 0',
      listStyle: 'none',
      marginBottom: '26px',
      position: 'relative',
      display: "flex",
      alignItems: 'center'
    },
    userBox: {
      width: '100%',
      textAlign: 'center',
      fontSize: '12px',
      color: '#999',
      fontWeight: '600',
      lineHeight: '20px',
      display: "flex",
      alignItems: "center",
      padding: "0 12px"
    },
    avatarStyle: {
      height: "28px",
      width: "28px",
      borderRadius: "50%"
    },
    userName: {
      // padding: "0 10px 4px",
      color: "#a5a5a5",
      fontSize: "14px",
      display: "inline-block",
      textAlign: "left"
    },
    joinTextStyle: {
      fontFamily: "Roboto",
      fontSize: "12px",
      fontWeight: "600",
      lineLeight: "16px",
      letterSpacing: "0.15px",
      textAlign: "left",
      color: "#FFFFFF",
      margin: "0 4px",
      display: "flex",
      alignItems: "center"
    },
    joinIconStyle: {
      marginLeft: "4px"
    }
  };
});

function Notify(_ref) {
  var _roomUserInfo$message, _roomUserInfo$message2;

  var message = _ref.message;
  var classes = useStyles();
  var easeLivestreamProps = useContext(EaseLivestreamContext);
  var roomUserInfo = easeLivestreamProps.roomUserInfo;
  return /*#__PURE__*/React.createElement("li", {
    className: classes.pulldownListItem
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    className: classes.avatarStyle,
    src: roomUserInfo && ((_roomUserInfo$message = roomUserInfo[message.from]) === null || _roomUserInfo$message === void 0 ? void 0 : _roomUserInfo$message.avatar) || avatar
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.userBox
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.userName
  }, ((_roomUserInfo$message2 = roomUserInfo[message.from]) === null || _roomUserInfo$message2 === void 0 ? void 0 : _roomUserInfo$message2.nickname) || message.from), /*#__PURE__*/React.createElement("span", {
    className: classes.joinTextStyle
  }, i18next.t("Joined"), /*#__PURE__*/React.createElement("img", {
    src: joinIcon,
    alt: "",
    className: classes.joinIconStyle
  }))));
}

export default memo(Notify);